/**
 * Extract a human-readable summary from an unknown error, preserving Firebase
 * error codes (e.g. 'permission-denied') so the user can self-diagnose rules
 * or quota issues instead of seeing a generic "Failed to load".
 */
export function describeError(err: unknown): string {
  if (err && typeof err === 'object') {
    const code = (err as { code?: unknown }).code;
    const message = (err as { message?: unknown }).message;
    if (typeof code === 'string' && typeof message === 'string') {
      if (code === 'permission-denied') {
        return `Permission denied — Firestore rules for this collection may not be deployed (${code}).`;
      }
      return `${code}: ${message}`;
    }
    if (typeof message === 'string') return message;
  }
  return String(err);
}
